import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FeeService } from '../../../services/FeeService';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import * as $ from 'jquery';
import { FeeEditDialogComponent } from '../fee-edit-dialog/fee-edit-dialog.component';
@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  styleUrls: ['./fee.component.css']
})
export class FeeComponent implements OnInit {
  constructor(private FeeService: FeeService, public snackBar: MatSnackBar, public dialog: MatDialog) { }
  Fees: any = {};
  Fee = {
    fieldID: "undefined", semester: 0, feeAmount: "undefined", year: "undefined", season: "undefined", branchId:0
  }
  ngOnInit() {
    this.FeeService.getAllFee(this.Fee).subscribe(r => this.Fees = r);
    console.log("Fees Here: " + this.Fees);
  }

  branchId: number = -1;
  userId: string = "";
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.branchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.branchId = 2;
      else
        this.branchId = 0;
      this.userId = dataAccessUrl.userId;
    }
    this.Fee.branchId = this.branchId;
  }


  editFee (fee: any): void {
    const dialogRef = this.dialog.open(FeeEditDialogComponent, {
      width: '250px',
      data: { feeID: fee["feeID"], year: fee["year"], season: fee["season"], fieldID: fee["fieldID"], semester:fee["semester"], feeAmount:fee["feeAmount"] }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.FeeService.getAllFee(this.Fee).subscribe(r => this.Fees = r);
    });
  }
  getFees(f: NgForm) {
    
    this.FeeService.getFee(f.value).subscribe(f => this.Fees = f);
    console.log(this.Fees);
  }
  deleteFee(feeID: string) {
    //const dialogRef = this.dialog.open(FeeComponent, {
    //  width: '250px',
    //  data: "آیا مطمین هستید؟"
    //});
    //dialogRef.afterClosed().subscribe(result => {
    //  console.log('The dialog was closed');
      
    //});
    if (confirm("آیا مطمین هستید؟")) {
      this.FeeService.deleteFee(feeID).subscribe();
      this.snackBar.open("فیس حذف شد", null, { duration: 5000 });
      $('tr[id="Row' + feeID + '"]').remove();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/fee/fee/fee.component.ts